import { mfaOtpSetup } from './mfaOtpSetup';

export const authentication = ($http: HttpApi) => ({
  mfaOtpSetup: mfaOtpSetup($http),
});
